import React from "react"

const SearchReset = ({
  resetClick,
  resetSearchText,
}: {
  resetClick: React.MouseEventHandler<HTMLButtonElement>
  resetSearchText: string
}) => {
  return (
    <button
      className="nav-search__reset-text"
      onClick={resetClick}
      aria-label="Reset search"
    >
      {resetSearchText}
    </button>
  )
}

export default SearchReset
